import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: top;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Label = styled.label`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  min-width: 20rem;
  padding: ${({ theme }) => theme.spacing(2)} 0;
`;

export const InputContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  width: 100%;
`;

export const ShortcutDisplay = styled.div<{
  $hasError: boolean;
  $focused: boolean;
  $disabled: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(2)}`};
  width: 100%;

  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  transition: border-color 200ms;

  display: flex;
  align-items: center;
  cursor: text;

  ${({ theme, $focused }) =>
    $focused &&
    css`
      border-color: ${theme.palette.primary.main};
    `};

  ${({ theme, $hasError }) =>
    $hasError &&
    css`
      border-color: ${theme.palette.error.main};
    `};

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.45;
      pointer-events: none;
    `};
`;

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
`;

export const Placeholder = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  pointer-events: none;
`;

export const EndContainer = styled.span`
  position: absolute;
  top: 50%;
  height: 100%;
  right: ${({ theme }) => theme.spacing(2)};

  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(0.5)};
  align-items: center;

  transform: translateY(-50%);
`;
